import { gql } from "@apollo/client";

export const GET_INITIATIVE_BY_ID = gql`
  query GetInitiativeById($getInitiativeByIdId: String!) {
    getInitiativeById(id: $getInitiativeByIdId) {
      id
      name
      organizationId
      description
      address
      images
      organizations {
        id
        logoUrl
        name
        email
      }
      service {
        name
        organization {
          name
        }
      }
    }
  }
`;
